export const PLACEHOLDER_PLUGIN_KEY = 'placeholder';
